import { Twitter, Instagram } from "lucide-react"
import { useLanguage } from "@/hooks/useLanguage"

interface FooterProps {
  /** @deprecated - language is now managed by LanguageContext. Remove when parent page is migrated. */
  language?: "es" | "en"
}
const Footer = (_props: FooterProps) => {
  const { t } = useLanguage()
  const text = t.footer
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-5 lg:gap-8">
          {/* Company Info */}
          <div className="flex flex-col">
            <div className="mb-6">
              <span className="font-display text-4xl tracking-display">MEATBID</span>
            </div>
            <p className="mb-8 max-w-xs text-sm leading-relaxed text-primary-foreground/70">
              {text.description}
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-foreground/20 text-primary-foreground transition-all hover:border-white hover:text-white"
              >
                <Twitter className="h-4 w-4" />
              </a>
              <a
                href="#"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-foreground/20 text-primary-foreground transition-all hover:border-white hover:text-white"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-6 inline-block border-b-2 border-accent pb-1 text-sm font-black uppercase tracking-widest">
              {text.quickLinks}
            </h4>
            <div className="space-y-4">
              {[
                { label: text.premiumCuts, href: "#" },
                { label: text.ourFarms, href: "#" },
                { label: text.bespokeOrders, href: "#" },
                { label: text.shippingPolicy, href: "#" },
              ].map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  className="block text-sm text-primary-foreground/70 transition-colors hover:text-white"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Customer Care */}
          <div>
            <h4 className="mb-6 inline-block border-b-2 border-accent pb-1 text-sm font-black uppercase tracking-widest">
              {text.customerCare}
            </h4>
            <div className="space-y-4">
              {[
                { label: text.trackOrder, href: "#" },
                { label: text.contactExpert, href: "#" },
                { label: text.returns, href: "#" },
                { label: text.faqs, href: "#" },
              ].map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  className="block text-sm text-primary-foreground/70 transition-colors hover:text-white"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="mb-6 inline-block border-b-2 border-accent pb-1 text-sm font-black uppercase tracking-widest">
              {text.legal}
            </h4>
            <div className="space-y-4">
              <a
                href="/privacy"
                className="block text-sm text-primary-foreground/70 transition-colors hover:text-white"
              >
                {text.privacy}
              </a>
              <a
                href="/terms"
                className="block text-sm text-primary-foreground/70 transition-colors hover:text-white"
              >
                {text.terms}
              </a>
              <a
                href="/cookies"
                className="block text-sm text-primary-foreground/70 transition-colors hover:text-white"
              >
                {text.cookies}
              </a>
            </div>
          </div>

          {/* Subscribe */}
          <div>
            <h4 className="mb-6 inline-block border-b-2 border-accent pb-1 text-sm font-black uppercase tracking-widest">
              {text.subscribeTitle}
            </h4>
            <p className="mb-6 text-sm text-primary-foreground/70">
              {text.subscribeText}
            </p>
            <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder={text.emailPlaceholder}
                className="w-full border-0 bg-white/10 px-4 py-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:ring-1 focus:ring-accent"
              />
              <button
                type="submit"
                className="w-full bg-[#b87333] px-4 py-3 text-xs font-black uppercase tracking-widest text-white transition-colors hover:bg-[#a66222]"
              >
                {text.joinCollection}
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-20 flex flex-col items-center justify-between border-t border-white/10 pt-8 md:flex-row">
          <p className="mb-4 text-xs font-medium uppercase tracking-wider text-primary-foreground/50 md:mb-0">
            {text.copyright}
          </p>
          <div className="flex space-x-8 text-xs font-medium uppercase tracking-wider text-primary-foreground/50">
            <a href="/privacy" className="transition-colors hover:text-white">
              {text.privacy}
            </a>
            <a href="/terms" className="transition-colors hover:text-white">
              {text.terms}
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
export default Footer

